<template>
  <div class="page-wrapper" id="app">
    <div class="page-inner">
      <!-- Меню -->
      <ComponentMenu/>
      <div class="page-content-wrapper">
          <!-- Шапка сайта -->
          <ComponentHeader/>
          <!-- Основной контент страницы -->
          <main id="js-page-content" role="main" class="page-content">
              <router-view/>
          </main>
          <!-- Мобильная навигация -->
          <div class="page-content-overlay" data-action="toggle" data-class="mobile-nav-on"></div>
          <!-- Подвал сайта -->
          <ComponentFooter/>
      </div>
    </div>
  </div>
</template>

<script>
  // Компоненты
  import ComponentMenu from '@/layouts/default/menu.vue'
  import ComponentHeader from '@/layouts/default/header.vue'
  import ComponentFooter from '@/layouts/default/footer.vue'

  export default {
    metaInfo: {
      title: 'Центр мониторинга',
      link: [
        { rel: 'stylesheet', href: '/css/vendors.bundle.css' },
        { rel: 'stylesheet', href: '/css/app.bundle.css' },
        { rel: 'stylesheet', href: '/css/themes/cust-theme-3.css' },
        { rel: 'stylesheet', href: '/css/custom.css' },
      ],
      htmlAttrs: {
        class: ['root-text-xl']
      },
    },
    components: {
      ComponentMenu,
      ComponentHeader,
      ComponentFooter,
    }
  }
</script>